import { Injectable } from '@angular/core';

import * as jwt_decode from 'jwt-decode';
import { ELanguage, IRequester, IUser, SUPPORTED_LANGUAGES } from 'libraries/interfaces/IUser';
import { ErrorTracingService } from '../error-tracing/error-tracing.service';
import { Yii } from "../../interfaces/Yii";
declare var xtoken: string; //use in wtb

@Injectable()
export class UserAuthService {

    public userInformations: IUser;
    private isLogged: boolean;
    private readonly lsPrefix: string = sessionStorage.getItem("$instance_url");

    constructor(
        private readonly errorTracingService: ErrorTracingService,
    ) {}


    public getRequester(): IRequester {
        this.loadUserInformations();

        if (typeof xtoken !== "undefined" && xtoken) {
            const xTokenDecode: IUser = jwt_decode(xtoken);

            return {
                company: { id: xTokenDecode.company },
                user: xTokenDecode.sam_uid,
            };
        }

        return undefined;
    }

    public getRequesterName(): string {
        this.loadUserInformations();

        if (typeof xtoken !== "undefined" && xtoken) {
            const xTokenDecode: IUser = jwt_decode(xtoken);

            return `${xTokenDecode.contact.title} ${xTokenDecode.contact.firstName} ${xTokenDecode.contact.lastName}`;
        }

        return undefined;
    }

    public getUserId(): number {
        this.loadUserInformations();
        const wuiId: number = this.userInformations?.sam_uid;
        if (wuiId && wuiId.toString() !== '') { //wui/app_** apps
            return wuiId;
        } else if (typeof xtoken !== "undefined" && xtoken) { //wtb
            return jwt_decode(xtoken).sam_uid;
        }

        return null;
    }

    public getCompanyId(): number {
        this.loadUserInformations();
        return this.userInformations?.sam_company;
    }

    /**
     * Token storage in sessionStorage
     * @res : Response from HTTP request
     */
    public storeToken(token: string): void {
        //store xtoken
        sessionStorage.setItem('xtoken', token);
        //store User Infos
        const userInformations: IUser = jwt_decode(token);

        sessionStorage.setItem('userInformations', JSON.stringify(userInformations));
        this.userInformations = userInformations;

        this.storeLanguage();
        //isLogged
        sessionStorage.setItem('isLogged', '1');
        this.isLogged = true;

        //store in localStorage to maintain connexion between tabs in browser
        localStorage.setItem(`${this.lsPrefix}_token`, token);
        localStorage.setItem(`${this.lsPrefix}_userInformations`, JSON.stringify(userInformations));
        localStorage.setItem(`${this.lsPrefix}_isLogged`, '1');

        // we register current user for additional details in error reporting
        this.errorTracingService.setUser(this.userInformations);
    }

    public setStorageOAuthToken(oAuthToken: string): void {
        localStorage.setItem(`${this.lsPrefix}_oAuthToken`, oAuthToken);
    }

    public setStorageOAuthTokenType(oAuthTokenType: string): void {
        localStorage.setItem(`${this.lsPrefix}_oAuthTokenType`, oAuthTokenType);
    }

    public getStorageOAuthToken(): string {
        return localStorage.getItem(`${this.lsPrefix}_oAuthToken`);
    }

    public getStorageOAuthTokenType(): string {
        return localStorage.getItem(`${this.lsPrefix}_oAuthTokenType`);
    }

    public removeStorageOAuthToken(): void {
        localStorage.removeItem(`${this.lsPrefix}_oAuthToken`);
    }

    public removeStorageOAuthTokenType(): void {
        localStorage.removeItem(`${this.lsPrefix}_oAuthTokenType`);
    }

    /**
     * Remove users Infos when logOut
     */
    public removeInfos(): void {
        sessionStorage.removeItem('xtoken');
        sessionStorage.removeItem('isLogged');
        sessionStorage.removeItem('userInformations');
        this.removeStorageOAuthToken();
        this.removeStorageOAuthTokenType();
        localStorage.removeItem(`${this.lsPrefix}_token`);
        localStorage.removeItem(`${this.lsPrefix}_userInformations`);
        localStorage.removeItem(`${this.lsPrefix}_isLogged`);
        this.userInformations = null;
        this.isLogged = false;

        this.errorTracingService.setUser(null);
    }


    public loadUserInformations(): boolean {
        if (!this.userInformations) {
            try {
                this.userInformations = JSON.parse(sessionStorage.getItem("userInformations"));
                this.isLogged = Boolean(this.userInformations);
                this.errorTracingService.setUser(this.userInformations);
            } catch (error) {
                this.errorTracingService.captureException(error);
                this.isLogged = false;
                this.userInformations = undefined;
            }
        }
        this.storeLanguage();
        return this.isLogged;
    }

    private storeLanguage(): void {
        if(this.userInformations &&
            this.userInformations.sam_contact &&
            this.userInformations.sam_contact.language &&
            SUPPORTED_LANGUAGES.includes(this.userInformations.sam_contact.language.toLowerCase() as ELanguage)){
            Yii.translate.config.language = this.userInformations.sam_contact.language.toLowerCase();
        }
    }

}
